import React, { PropsWithChildren, useEffect } from 'react';
import Layout from './molecules/Layout/Layout';
import { AdminAuthContext } from '../auth/authContext';
import { abilities } from '../auth/abilities';
import AdminRoutes from './AdminRoutes';
import { AlertError } from '../../base/components/atoms/Alert';
import useMe from '../../base/auth/hooks/useMe';
import { base, useAgnosticGuiContext } from '@sdxcorp/sdx-dds-gui-lib';
import { AuthContext } from '../../base/auth/context';
import useEnvConfig from '../../base/auth/hooks/useEnvConfig';

const {
  atoms: { Spinner },
} = base;

export let globalSnbDltNodeName: string | undefined = undefined;

const AdminApp: React.FC<PropsWithChildren> = ({ children }) => {
  const { setUserData } = useAgnosticGuiContext();
  const { loading, me, statusCode } = useMe();
  const { envType, snbDltNodeName } = useEnvConfig();
  const userId = me?.user.userId ?? undefined;
  const sdxMemberId = me?.member.sdxMemberId ?? undefined;
  useEffect(() => {
    setUserData({ userId, sdxMemberId });
  }, [userId, sdxMemberId, setUserData]);

  // wait for redirect to login screen if we get 401
  if (loading || statusCode === 401) {
    return <Spinner.FullContentSpinner disabled />;
  }
  if (!me && !loading) {
    return <AlertError>Error</AlertError>;
  }
  globalSnbDltNodeName = snbDltNodeName;
  let user: AuthContext['user'];
  let member: AuthContext['member'];
  if (me) {
    const firstName = me.user.givenName || '';
    const lastName = me.user.familyName || '';
    user = {
      id: userId || '',
      firstName,
      lastName,
      name: `${firstName} ${lastName}`,
      memberId: '' + me.member?.sdxMemberId,
      roles: (me.user.userRoles as string[]) || [],
      actingMember: me.user.actingMember,
    };
    member = {
      id: me.member?.id,
      sdxMemberId: '' + me.member?.sdxMemberId,
      dltNodeName: me.member?.dltNodeName,
      name: me.legalEntity?.name,
      roles: (me.memberRoles as string[]) || [],
      assetTypes: me.assetTypes ?? [],
    };
  }

  return (
    <AdminAuthContext.Provider
      value={{
        abilities,
        member,
        loading,
        user,
        env: envType || '',
      }}
    >
      <Layout>
        <AdminRoutes />
        {children}
      </Layout>
    </AdminAuthContext.Provider>
  );
};

export default AdminApp;
